export default __webpack_public_path__ + "static/media/icn_clock.7f8ffa6f.svg";